import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/modules/auth/login/pages/Auth'
import RecoverPassword from '@/modules/auth/login/pages/RecoverPassword'
import RecoverPasswordSendCode from '@/modules/auth/login/pages/RecoverPasswordSendCode'
import Signup from '@/modules/auth/signup/pages/Signup'
import SignupDone from '@/modules/auth/signup/pages/SignupDone'
import VerifyNumber from '@/modules/auth/signup/pages/VerifyNumber'
import Home from '@/modules/home/pages/Home'
import Checkin from '@/modules/checkin/pages/Checkin'
import Shops from '@/modules/shop/pages/Shops'
import Shop from '@/modules/Shop/pages/Shop'
import Products from '@/modules/Shop/pages/Products'
import Cart from '@/modules/Shop/pages/Cart'
import Services from '@/modules/Shop/pages/Services'
import Checkout from '@/modules/Shop/pages/Checkout'
import ServicesCheckout from '@/modules/Shop/pages/ServicesCheckout'
import ServicesOrderSummary from '@/modules/Shop/pages/ServicesOrderSummary'
import CheckoutDone from '@/modules/Shop/pages/CheckoutDone'
import Profile from '@/modules/profile/pages/Profile'
import Terms from '@/modules/terms/pages/Terms'
import ServicesOffered from '@/modules/terms/pages/ServicesOffered'
import Orders from '@/modules/Order/pages/Orders'
import OrderDetail from '@/modules/Order/pages/OrderDetail'
import Stripe from '@/modules/shop/pages/Stripe'
import noticesPage from '@/modules/common/components/notices/noticesPage'

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        backButton: {
          enabled: false,
          name: ''
        },
        bottomBar: false,
      }
    },
    {
      path: '/',
      name: 'auth',
      component: Auth,
      meta: {
        backButton: {
          enabled: false,
          name: ''
        },
        bottomBar: false,
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: {
        backButton: {
          enabled: false,
          name: ''
        },
        bottomBar: false
      }
    },    
    {
      path: '/auth/recover',
      name: 'auth.recover',
      component: RecoverPassword,
      meta: {
        title: "Recupero Password",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    }, 
    {
      path: '/auth/recover/send-code',
      name: 'auth.recover.sendcode',
      component: RecoverPasswordSendCode,
      meta: {
        title: "Recupero Password",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },        
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta: {
        title: "Registrazione",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },
    {
      path: '/signup/done',
      name: 'signup.done',
      component: SignupDone,
      meta: {
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }      
    },
    {
      path: '/signup/verify-number',
      name: 'signup.verifyNumber',
      component: VerifyNumber,
      meta: {
        title: "Verifica Account",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },
    {
      path: '/checkin',
      name: 'checkin',
      component: Checkin,
      meta: {
        title: "Check-in",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },
    {
      path: '/shops',
      name: 'shops',
      component: Shops,
      meta: {
        title: "Lista Shop",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
        loader: true
      }
    }, 
    {
      path: '/shop/:id',
      name: 'shop',
      component: Shop,
      meta: {
        title: "Info",
        backButton: {
          enabled: true,
          name: 'home'
        },
        bottomBar: false
      }
    },
    {
      path: '/shop/:id/products',
      name: 'shop.products',
      component: Products,
      meta: {
        title: "Menu",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: true,
        showShopName: true
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
      meta: {
        title: "Carrello",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: true,
        showShopName: true
      }
    },
    {
      path: '/shop/:id/services',
      name: 'shop.services',
      component: Services,
      meta: {
        title: "Prenotazione",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
        showShopName: true,
        loader: true
      }
    },    
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      meta: {
        title: "Concludi Ordine",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
        showShopName: true
      }
    },
    {
      path: '/services-order-summary',
      name: 'services.order.summary',
      component: ServicesOrderSummary,
      meta: {
        title: "Conferma Prenotazione",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
        showShopName: true
      }
    },   
    {
      path: '/services-checkout',
      name: 'services.checkout',
      component: ServicesCheckout,
      meta: {
        title: "Pagamento",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
        showShopName: true
      }
    },        
    {
      path: '/checkout/done',
      name: 'checkout.done',
      component: CheckoutDone,
      meta: {
        title: "Ordine inviato",
        backButton: {
          enabled: true,
          name: 'home'
        },
        bottomBar: false
      }
    },    
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        title: "Profilo",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: true,
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        title: "T&C",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
      }
    },
    {
      path: '/services-offered',
      name: 'servicesoffered',
      component: ServicesOffered,
      meta: {
        title: "Servizi Offerti",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false,
      }
    },
    {
      path: '/profile/orders',
      name: 'orders',
      component: Orders,
      meta: {
        title: "Lista Ordini",
        backButton: {
          enabled: true,
          name: 'home'
        },
        bottomBar: true,
        loader: true
      }
    },
    {
      path: '/profile/order/:id',
      name: 'order.detail',
      component: OrderDetail,
      meta: {
        title: "Info Ordine",
        backButton: {
          enabled: true,
          name: 'orders'
        },
        bottomBar: true
      }
    },        
    {
      path: '/stripe',
      name: 'stripe',
      component: Stripe,
      meta: {
        title: "Pagamento",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },        
    {
      path: '/notices',
      name: 'notices',
      component: noticesPage,
      meta: {
        title: "Notifica",
        backButton: {
          enabled: true,
          name: ''
        },
        bottomBar: false
      }
    },        
  ]
})


// WEBPACK FOOTER //
// ./src/router/routes/index.js